import { PLATFORM_REGEXS } from '../constants'

const referrerHostname = traffic => {
  if (traffic.referrer === '') {
    return ''
  }
  const referrerObject = new URL(traffic.referrer.toLowerCase())
  const hostname = referrerObject.hostname
  for (let platform in PLATFORM_REGEXS) {
    if (PLATFORM_REGEXS[platform].some(regex => regex.test(hostname))) {
      return platform
    }
  }
  return hostname
}

export default referrerHostname



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/selectors/referrerHostname.js